import { StripePaymentProcessor } from './StripePaymentProcessor.js'
import { PaypalPaymentProcessor } from './PaypalPaymentProcessor.js'
import {
  PaymentProcessor,
  PaymentProcessorClasses,
  PaymentProcessorOptions, PaymentProcessorTypes
} from "./PaymentProcessor.js"

export default class PaymentProcessorFactory {
  public static instance: PaymentProcessorFactory
  public static stripePaymentProcessor: PaymentProcessor
  public static paypalPaymentProcessor: PaymentProcessor

  /**
   * creates a PaymentProcessor instance and returns it
   * @param type: PaymentProcessorTypes
   * @param key: string
   * @param options: PaymentProcessorOptions
   * @param onLoad: () => void
   */
  public static async createProcessor (
    processorClass: PaymentProcessorClasses,
    type: PaymentProcessorTypes,
    key: string,
    options: PaymentProcessorOptions,
    onLoad: () => void
  ): Promise<PaymentProcessor> {
    if (!this.instance) {
      this.instance = new PaymentProcessorFactory()
    }

    if (!Object.values(PaymentProcessorClasses).includes(processorClass)) {
      throw new Error('Invalid payment processor class. Check "PaymentProcessorClasses" for valid options.')
    }

    let processor: PaymentProcessor

    switch (processorClass) {
      case PaymentProcessorClasses.STRIPE:
        if (this.stripePaymentProcessor) {
          processor = this.stripePaymentProcessor
        } else {
          processor = new StripePaymentProcessor()
          this.stripePaymentProcessor = processor
        }

        return processor.fetchProcessor(type, key, options, onLoad)
      case PaymentProcessorClasses.PAYPAL:
        if (this.paypalPaymentProcessor) {
          processor = this.paypalPaymentProcessor
        } else {
          processor = new PaypalPaymentProcessor()
          this.paypalPaymentProcessor = processor
        }

        return processor.fetchProcessor(type, key, options, onLoad)
      default:
        throw new Error('Invalid payment processor class')
    }
  }

  /**
   * returns a stripe payment processor instance if one exists
   */
  public static getActiveStripePaymentProcessor (): PaymentProcessor {
    return this.stripePaymentProcessor
  }
}
